import React, { useState, useReducer, useEffect, useContext } from "react";
import { Alert, Col, Row, Tab, Tabs } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { BreadcrumbContext } from "../../../contexts/BreadcrumbContext";
import queryString from "query-string";
import moduleConfig from "./moduleConfig";
import DashboardLayout from "../../UI/layouts/DashboardLayout";
import BlockErrorMessage from "../../UI/errorMessages/BlockErrorMessage";
import ModuleHeader from "../../UI/modules/views/partials/common/ModuleHeader";
import FormErrorMessage from "../../UI/errorMessages/FormErrorMessage";
import useConfirm from "../../../HOC/custom/useConfirm";
import ListingFooter from "./partials/listing/ListingFooter";
import SearchArea from "./partials/listing/SearchArea";
import Item from "./partials/listing/Item";
import { OverlayLoading } from "../../UI/loading/OverlayLoading";
import {
  listingInitialState,
  listingReducer,
} from "../../../reducers/module/listingReducer";
import {
  loadItemsGeneral,
  setFilterGeneral,
  resetFiltersGeneral,
  confirmAndDisabledGeneral,
  confirmAndEnabledGeneral,
} from "../../../helpers/ModuleHelperFunctions";

const MenuListing = () => {
  const { setBreadcrumb } = useContext(BreadcrumbContext);
  const { confirm } = useConfirm();
  const { search } = useLocation();
  let history = useNavigate();
  const [listingState, listingDispatch] = useReducer(
    listingReducer,
    listingInitialState
  );
  const [appliedFilters, setAppliedFilters] = useState(
    queryString.parse(search)
  );
  const [activeTab, setActiveTab] = useState("0");

  // Load saved tab index from localStorage on mount
  useEffect(() => {
    const savedTab = localStorage.getItem("activeWeekTab");
    if (savedTab) {
      setActiveTab(savedTab);
    }
  }, []);

  // Save tab index to localStorage whenever changed
  const handleTabSelect = (key) => {
    setActiveTab(key);
    localStorage.setItem("activeWeekTab", key);
  };
  if (appliedFilters.limit) {
    moduleConfig.perPageItems = appliedFilters.limit;
  }

  const setFilter = (name, value) => {
    setFilterGeneral(name, value, appliedFilters, setAppliedFilters, history);
  };

  const resetFilters = () => {
    resetFiltersGeneral(
      appliedFilters,
      setAppliedFilters,
      history,
      moduleConfig
    );
  };

  const confirmAndDisabled = async (id) => {
    let res = await confirmAndDisabledGeneral(
      id,
      `${moduleConfig.url}/change-status`,
      confirm,
      listingDispatch
    );
    //console.log(res)
    if (res) {
      loadItemsGeneral(listingDispatch, moduleConfig.url, search);
    }
  };

  const confirmAndEnabled = async (id) => {
    let res = await confirmAndEnabledGeneral(
      id,
      `${moduleConfig.url}/change-status`,
      confirm,
      listingDispatch
    );
    //console.log(res)
    if (res) {
      loadItemsGeneral(listingDispatch, moduleConfig.url, search);
    }
  };

  useEffect(() => {
    loadItemsGeneral(listingDispatch, moduleConfig.url, search);
  }, [search]);

  useEffect(() => {
    setBreadcrumb([moduleConfig.breadcrumbs.listing]);
  }, []);

  return (
    <DashboardLayout>
      {listingState.isLoading && <OverlayLoading />}

      {listingState.status !== "fetching" && (
        <>
          {listingState.error && listingState.status === "fetchFailed" ? (
            <BlockErrorMessage error={listingState.error} />
          ) : (
            <>
              <ModuleHeader
                moduleTitle={moduleConfig.title}
                moduleUrl={moduleConfig.url}
              ></ModuleHeader>

              <div className="listingPage">
                {listingState.data ? (
                  <>
                    {/* Listing */}
                    <section className="content listing ">
                      {listingState.error && (
                        <FormErrorMessage error={listingState.error} />
                      )}

                      <>
                        <Tabs
                          defaultActiveKey="0"
                          id="custom-tabs"
                          className="custom-tabs mb-2"
                          activeKey={activeTab}
                          onSelect={handleTabSelect}
                        >
                          {listingState.data.tabHeadings &&
                            listingState.data.tabHeadings.length > 0 &&
                            listingState.data.tabHeadings.map(
                              (heading, index) => (
                                <Tab
                                  key={index}
                                  eventKey={index.toString()}
                                  title={`Week (${heading.dates})`}
                                >
                                  {listingState.data.remainingDaysDates &&
                                  listingState.data.remainingDaysDates.length >
                                    0 ? (
                                    <>
                                      {listingState.data.remainingDaysDates
                                        .filter(
                                          (item) => item.week === heading.week // 👈 filter items by week
                                        )
                                        .map((item, itemIndex) => (
                                          <Item
                                            key={itemIndex}
                                            moduleConfig={moduleConfig}
                                            item={item}
                                            data={listingState?.data}
                                            tab={index}
                                            customButtonsForItems={[]}
                                            loadItems={() =>
                                              loadItemsGeneral(
                                                listingDispatch,
                                                moduleConfig.url,
                                                search
                                              )
                                            }
                                          />
                                        ))}
                                    </>
                                  ) : (
                                    <p className="text-center text-muted py-3">
                                      No items available for this week.
                                    </p>
                                  )}
                                </Tab>
                              )
                            )}
                        </Tabs>
                      </>
                    </section>

                    <ListingFooter
                      listingState={listingState}
                      moduleConfig={moduleConfig}
                      setFilter={setFilter}
                    />
                  </>
                ) : (
                  <Alert className="alert-custom-1">No records found.</Alert>
                )}
              </div>
            </>
          )}
        </>
      )}
    </DashboardLayout>
  );
};

export default MenuListing;
